import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewWillEnter, ViewWillLeave } from '@ionic/angular';
import { CadastroContratoAssinaturaTipoEnvioLink, CadastroContratoTipoAssinatura } from '@usucampeao/interfaces';
import { ErrorCode } from '@usucampeao/lib-reurb-simplificado';
import { CadastroFichaDto, LoadingService, NavigationService, ToastService } from '@usucampeao/ui-mobile';
import { Subject } from 'rxjs';
import { catchError, finalize, switchMap, takeUntil, tap } from 'rxjs/operators';
import { CadastrosQuery } from '../../../state/cadastros.query';
import { CadastroService } from '../../../state/cadastros.service';

@Component({
  templateUrl: 'comprovante-renda-selecionar-tipo-assinatura.page.html',
  styleUrls: ['comprovante-renda-selecionar-tipo-assinatura.page.scss'],
})
export class ComprovanteRendaSelecionarTipoAssinaturaPage implements ViewWillEnter, ViewWillLeave, OnDestroy {
  private ngUnsubscribe$ = new Subject();
  private cadastroFichaDto: CadastroFichaDto;

  constructor(
    private cadastroQuery: CadastrosQuery,
    private cadastroService: CadastroService,
    private loadingService: LoadingService,
    private navigationService: NavigationService,
    private router: Router,
    private route: ActivatedRoute,
    private toastService: ToastService,
  ) { }

  ionViewWillEnter(): void {
    this.route.params
      .pipe(
        switchMap(params => this.cadastroQuery.buscarCadastroFicha(params.cadastroId)),
        tap(cadastro => this.cadastroFichaDto = cadastro),
        takeUntil(this.ngUnsubscribe$),
      )
      .subscribe();
  }

  ionViewWillLeave(): void {
    this.ngUnsubscribe$.next();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.complete();
  }

  public get cadastroContratoTipoAssinatura(): typeof CadastroContratoTipoAssinatura {
    return CadastroContratoTipoAssinatura;
  }

  public goTo(route: string): void {
    this.router.navigate([route], { relativeTo: this.route })
  }

  public verificarSeTipoPorLinkESelecionarTipoAssinatura(tipo: CadastroContratoTipoAssinatura): void {
    this.selecionarTipoAssinatura(tipo);
  }

  private async selecionarTipoAssinatura(tipo: CadastroContratoTipoAssinatura, tipoEnvioLink?: CadastroContratoAssinaturaTipoEnvioLink) {
    await this.loadingService.createLoader();
    this.cadastroService.selecionarTipoAssinaturaComprovanteRenda(this.cadastroFichaDto.id, tipo)
      .pipe(
        tap(() => this.goTo(`../assinar`)),
        catchError(async error => {
          let message = 'Erro ao selecionar tipo de assinatura. Por favor tente novamente.';
          if (error?.error?.errorCode === ErrorCode.REGISTRATION_EXPIRED_CONTRACT) {
            message = 'Contrato está expirado! Por favor selecione outra forma de pagamento e gere o contrato novamente.';
          }

          await this.toastService.error(message).toPromise();
          throw error;
        }),
        finalize(() => this.loadingService.dismiss())
      )
      .subscribe();
  }

  public voltar(): void {
    this.navigationService.voltar();
  }
}
